<template lang="pug">
	.campaign-stations-map.flex-col.space-medium(v-if="activated")
		Loader(v-if="isLoading", :text="$tCaption('Loading', '@actions')", :fullscreen="true")
		template(v-else)
			StationsMapSelector(ref="selector", :selected="campaign.Stations", @add="v => addStations(v)", @remove="v => v && removeStation(v.Oid)", 
				:disabled="info.readonly", :onlyMyStations="$auth.proposalSettings().onlyMyStations", :mapPosition="mapPosition")
</template>

<script>
	import Loader from 'app-core/Loader.vue';
	import campaignStations from './campaign-stations.js';
	import StationsMapSelector from 'view/station/MapSelector.vue';

	export default {
		translationCategory: 'campaign.Detail',
		name: 'campaign-stations',
		mixins: [campaignStations],
		props: ['activated', 'mapPosition'],
		components: {
			Loader, StationsMapSelector
		},
		data() {
			return {
			};
		},		
		mounted() {
			if (__DEBUG__)
				window.campaignStationsMap = this;
		},
		methods: {

		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.campaign-stations-map {
		min-height: 280px;
	}
</style>